import React from 'react';
import './utils/apiAuth'; // токен во все запросы к API + выход при 401
import ReactDOM from 'react-dom/client';
import { initTheme } from './utils/theme';
import './components/styles/themes.css';
import './components/styles/app-mode.css';
import { initAppMode } from './utils/appMode';
import App from './App';
import {store} from "./reducers";
import {Provider} from "react-redux";

initTheme();
initAppMode(); // установленное приложение: без зума, «резинки» и выделения текста

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);


